/**
 * Temporary "in development" screen for the Dessert Architect.
 * Shown to any authenticated non-admin/non-editor user who tries to open
 * the Architect while it remains under active development.
 *
 * Admins and editors bypass this gate and see the real Architect.
 * Card + gate can be removed with a single line in App.js when the tool
 * is ready for public release. Nothing about the Architect itself changes.
 */
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Architect from "@/pages/Architect";

export default function ArchitectGate() {
  const nav = useNavigate();
  const { user } = useAuth();
  // Explicit whitelist — only admin/editor may reach the real Architect.
  // Any other role (student, undefined, null, empty string) shows the gate.
  const role = (user && typeof user === "object" && user.role) ? String(user.role).toLowerCase() : "";
  const isPrivileged = role === "admin" || role === "editor";

  if (isPrivileged) {
    return <Architect />;
  }

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-6 py-16"
      style={{ background: "#EFE6D5", color: "#3B241A" }}
      data-testid="architect-in-development">
      <div className="max-w-[560px] text-center">
        <div className="text-[10px] tracking-[0.48em] uppercase opacity-70 mb-6"
             data-testid="architect-in-development-brand">
          ANOKINA STUDIO
        </div>

        <h1
          className="font-serif leading-[0.98] mb-4"
          style={{
            fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
            fontSize: "clamp(44px, 6vw, 72px)",
            color: "#2A1810",
          }}
          data-testid="architect-in-development-title">
          Архитектор&nbsp;десертов
        </h1>

        <div className="italic text-[19px] opacity-80 mb-10"
             data-testid="architect-in-development-status">
          Сейчас в разработке
        </div>

        <p className="text-[15.5px] leading-[1.9] opacity-90 mb-10"
           data-testid="architect-in-development-body">
          Здесь появится интерактивный инструмент для создания и анализа
          десертов — со слоями, сочетаниями вкусов и технологическими
          рекомендациями.
        </p>

        <div className="text-[11px] tracking-[0.38em] uppercase opacity-60 mb-10">
          Скоро в Anokina&nbsp;Studio
        </div>

        <button
          type="button"
          onClick={() => nav("/hall")}
          className="px-8 py-3 rounded-full text-[12px] tracking-[0.28em] uppercase"
          style={{ background: "#2A1810", color: "#EFE4D0" }}
          data-testid="architect-in-development-back">
          Вернуться в главный холл
        </button>
      </div>
    </div>
  );
}
